import SignupPageExtension from "../../../@libs/Extensions/SignupPageExtension";

class SignupWithEmailStore extends SignupPageExtension {
	constructor(rootStore) {
		super(rootStore);
	}

	signup(...args) {
		return super.signup(...args);
	}
}

export default SignupWithEmailStore;
